.alert {
  &:global(.MuiAlert-root) {
    border: 1px solid transparent;
    border-radius: 0.375rem;
    padding: 0.8125rem;
  }

  &:global(.MuiAlert-standardError) {
    background: rgb(255 54 101 / 12%);
    border-color: rgb(255 54 101 / 30%);
    color: var(--pm-red);
  }

  :global(.MuiAlert-icon) {
    padding: 0;
  }

  :global(.MuiAlert-message) {
    color: inherit;
    padding: 0;
    width: 100%;
  }

  :global(.MuiAlert-action) {
    color: inherit;
    margin-right: 0;
    padding: 0;

    :global(.MuiButtonBase-root) {
      color: inherit;
      padding: 0;
    }
  }

  &Title:global(.MuiAlertTitle-root) {
    color: inherit;
    font-size: 0.875rem;
    font-weight: 600;
    letter-spacing: -0.03em;
    line-height: 1.4;
    margin: 0 0 0.25rem;
  }
}
